// Render the catalog's reviewed options without guessing provider capabilities.
export function generationParameterLabel(parameter, value = parameter?.value) {
  const label = parameter?.ui?.displayName || parameter?.name?.replace(/_/g, ' ') || 'Setting';
  if (value === null || value === undefined || value === '') return label;
  // Catalog option values and UI-selected values do not always share a type
  // (numeric option 5 vs selected "5"); a strict-only lookup silently drops
  // the reviewed option label.
  const options = parameter?.validation?.options || [];
  const option = options.find(item => item.value === value)
    || options.find(item => String(item?.value) === String(value));
  const formatted = option?.label || (typeof value === 'boolean' ? (value ? 'On' : 'Off') : String(value));
  return `${label}: ${formatted}`;
}

export function modelGenerationSettings(model) {
  if (!model?.capabilities?.output?.hasVideo && !model?.capabilities?.output?.hasImages) return [];
  return (model.parameters || []).filter(parameter =>
    parameter?.flags?.isVisibleToUsers !== false &&
    !parameter?.flags?.isAdminOnly &&
    parameter?.name !== 'prompt' &&
    !['file', 'image', 'audio', 'video'].includes(parameter?.ui?.component)
  ).map(parameter => {
    const options = parameter.validation?.options;
    const range = parameter.validation?.number;
    const choices = options?.length ? options.map(option => option.label || String(option.value)).join(' · ')
      : range?.min != null && range?.max != null ? `${range.min}–${range.max}`
        : parameter.description || 'Set in the conversation controls';
    return {
      name: parameter.name,
      label: parameter.ui?.displayName || parameter.name?.replace(/_/g, ' ') || 'Setting',
      choices,
      defaultLabel: parameter.value != null ? generationParameterLabel(parameter) : null,
    };
  });
}

export function parameterAffectsMediaQuote(parameter, models = []) {
  return !!parameter?.modelId && models.some(model =>
    String(model?.id || model?._id) === String(parameter.modelId) &&
    (model?.capabilities?.output?.hasVideo || model?.capabilities?.output?.hasImages)
  );
}
